import React, { useEffect, useState, useRef } from "react";
import { Link, usePage } from "@inertiajs/react";

interface NavbarProps {
    user?: boolean;
}

export default function Navbar({ user = false }: NavbarProps) {
    const { appName } = usePage().props;
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);
    const dropdownRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (query.length < 2) {
            setResults([]);
            return;
        }

        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
            fetch(`/search?q=${encodeURIComponent(query)}`)
                .then((res) => res.json())
                .then((data) => setResults(data))
                .catch(() => setResults([]));
        }, 250);
    }, [query]);

    // Закрыть dropdown при клике вне
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        // if (query.trim()) {
        //     window.location.href = `/search?q=${encodeURIComponent(query.trim())}`;
        // }
    };

    return (
        <>
            <header className="w-full border-b-[1px]">
                <nav className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-x-5">
                    {/* Logo */}
                    <ul className="md:min-w-60">
                        <li>
                            <Link href="/" className="text-lg font-medium">
                                {appName as string}
                            </Link>
                        </li>
                    </ul>

                    {/* Search */}
                    <div className="relative flex flex-1 max-w-[500px]" ref={dropdownRef}>
                        <form onSubmit={handleSearchSubmit} className="flex flex-1 w-full">
                            <input
                                type="text"
                                placeholder="Search"
                                className="w-full px-3 py-2 border border-gray-300 rounded-l text-sm focus:outline-none"
                                value={query}
                                onFocus={() => setShowDropdown(true)}
                                onChange={(e) => setQuery(e.target.value)}
                            />
                            <button
                                type="submit"
                                className="bg-blue-500 text-white px-4 rounded-r-md text-sm hover:bg-blue-600 focus:outline-none"
                            >
                                Search
                            </button>
                        </form>

                        {/* Suggestions dropdown */}
                        {showDropdown && results.length > 0 && (
                            <div className="absolute top-full mt-1 left-0 w-full bg-white border border-gray-200 rounded shadow z-50">
                                <ul className="divide-y divide-gray-100">
                                    {results.map((product) => (
                                        <li key={product.id}>
                                            <Link
                                                href={`/products/${product.alias}`}
                                                className="block px-4 py-2 hover:bg-gray-100 text-sm"
                                            >
                                                {product.name}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>

                    {/* Right nav */}
                    <ul className="flex md:min-w-60 justify-end space-x-9">
                        {/* <li>
                        <a href="https://admin.pricehunt.titarlab.com/">Admin</a>
                    </li> */}
                    </ul>
                </nav>
            </header>
            <div className="w-full border-b-[1px]">
                <nav className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between gap-x-5">
                    {/* Logo */}
                    <ul className="md:min-w-60 flex space-x-9">
                        <li>
                            <Link href="/categories">Categories</Link>
                        </li>
                        {/* <li>
                            <a href="/blog">Blog</a>
                        </li> */}
                        <li>
                            <Link href="/about-us">About</Link>
                        </li>
                        {user ? (
                            <li>
                                <Link href="/collections/mini-led-tvs">Mini-LED TVs</Link>
                            </li>
                        ) : null}
                    </ul>

                    {/* Right nav */}
                    <ul className="flex md:min-w-60 justify-end space-x-9">
                        {/* <li>
                        <a href="https://admin.pricehunt.titarlab.com/">Admin</a>
                    </li> */}
                    </ul>
                </nav>
            </div>
        </>
    );
}
